var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.filteredSessionList.length > 0
    ? _c(
        "div",
        { staticClass: "session-list" },
        _vm._l(_vm.filteredSessionList, function (item) {
          return _c(_vm.getComponentType(item), {
            key: item.session_id,
            tag: "component",
            attrs: { session: item },
            on: { stop: _vm.deleteSession },
          })
        }),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }